import * as lib from '~/dependencies';
import colors from '~/layout/colors';

export const Container = lib.styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  width: 40px;
  height: 20px;
  margin-left: 1px;
  margin-right: 1px;
`;

export const Bar = lib.styled.span`
  position: absolute;
  left: ${props => props.height * 6}px;
  bottom: 0;
  width: 5px;
  height: calc(15px * ${props => props.height} / 5);
  border: none;
  background-color: ${props =>
    props.barLen === 1 ? colors.green06 : colors.lightGray02};
  margin-left: 1px;
  margin-right: 1px;
`;
